/* eslint-disable import/prefer-default-export */
import qs from "query-string";
import assets from "../../services/apis/sportradarApi";
import {
  appendObjectToAsset,
  standardizeStreamObject,
} from "../asset";
import images from "../images";

const getSRAssetContent = (asset) => {
  if (!asset) return null;
  if (asset.teaserType === "content") return asset;
  if (!asset.content) return null;
  let content = asset.content;
  if (content[0]) content = content[0];

  return content;
};

export const getSRAssetTitle = (asset) => {
  const content = getSRAssetContent(asset);
  if (
    content &&
    content.editorial &&
    content.editorial.translations &&
    content.editorial.translations.en &&
    content.editorial.translations.en.title
  ) {
    return content.editorial.translations.en.title;
  }
  return "";
};

export const getSRAdCategory = (url) => {
  const { query } = qs.parseUrl(url);
  return query?.iu?.split("/")[3];
};

export const getSRAssetDescription = (asset) => {
  const content = getSRAssetContent(asset);
  if (
    content &&
    content.editorial &&
    content.editorial.translations &&
    content.editorial.translations.en &&
    content.editorial.translations.en.description
  ) {
    return content.editorial.translations.en.description;
  }
  return "";
};

export const getSRAssetChannelTitle = (asset) => {
  const category = getSRAssetCategory(asset);
  return category?.name || "";
};

export const getSRAssetContentPartnerName = (asset) => {
  const category = getSRAssetContentPartner(asset);
  return category?.name || "";
};

export const getSRAssetCategory = (asset) => {
  const content = getSRAssetContent(asset);
  if (content && content.event && content.event.category2) {
    return content.event.category2;
  }
  if (asset && asset.category2) {
    return asset.category2;
  }
  return null;
};

export const getSRAssetContentPartner = (asset) => {
  const content = getSRAssetContent(asset);
  if (content && content.event && content.event.category1) {
    return content.event.category1;
  }
  if (asset && asset.category1) {
    return asset.category1;
  }
  return null;
};

export const getSRThumbnail = (asset, manipulation = "original") => {
  const content = getSRAssetContent(asset);
  return images.getSRContentImage(
    content?.editorial?.image?.path,
    manipulation
  );
};

export const getSRAssetDuration = (asset) => {
  const content = getSRAssetContent(asset);
  return content?.duration || content?.playtime;
};

export const getSRAssetMetadata = (asset, metaId) => {
  const content = getSRAssetContent(asset);
  return (
    content?.clientMetadata?.[metaId] ||
    content?.clientMetadata?.find((e) => e.type?.name === metaId)?.name ||
    undefined
  );
};

export const getSREPGStartTime = (asset) => {
  if (asset && asset.start) {
    return asset.start;
  }
  return "";
};

export function getSRStream(asset) {
  let streamableAsset = asset;
  const content = getSRAssetContent(asset);
  return assets
    .getPlayerSettings(content.id)
    .then(() => assets.getRelatedElements(content.id))
    .then((response) => {
      streamableAsset = appendObjectToAsset(streamableAsset, {
        related: response?.data?.data,
      });
    })
    .catch((response) => {
      console.error(
        "[SportRadar] There was an error retrieving the related elements.",
        response
      );
    })
    .then(() => assets.getStreamURL(content.id))
    .then((response) =>
      standardizeStreamObject(
        response.data.data.stream,
        "application/x-mpegurl"
      )
    )
    .then((streamObject) => {
      streamableAsset = appendObjectToAsset(streamableAsset, streamObject);
      return streamableAsset;
    });
}
